import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@src/redux/actions';
import { VOICE_PROVIDER } from '@src/constants/voice';
import { Button, Typography } from '@mui/material';
import VoiceSelectionDialog from '@src/containers/VoiceSelectionDialog';
import BadgeAvatar from '@src/components/BadgeAvatar';
import moment from 'moment';
import { SUB_STATUS } from '@src/constants/voiceCloning';
import Tooltip from '@src/components/Tooltip';
import { convertFormatDate } from '@src/utils/date';
import { useTranslation } from 'react-i18next';
import RunningWithErrorsRoundedIcon from '@mui/icons-material/RunningWithErrorsRounded';
import LimitedFeature from '@src/components/LimitedFeature';
import { StyledMenuVoice } from './index.style';

const MenuVoice = () => {
  const dispatch = useDispatch();
  const { voice } = useSelector((state) => state.dubbingRequest);
  const { dubbingVoices } = useSelector((state) => state.voice);
  const [openVoices, setOpenVoices] = useState(false);
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.user);
  const isInValidPublicVoiceCloning =
    voice?.userId !== user?.id &&
    voice?.discardAt &&
    moment().isAfter(voice?.discardAt);

  const isPublicVoiceCloning = voice?.status === SUB_STATUS.PUBLIC;
  const isVoiceCloningAboutToRemoved =
    isPublicVoiceCloning && voice?.discardAt
      ? moment().isBefore(voice?.discardAt)
      : false;

  const setDefaultVoice = () => {
    dispatch(
      actions.dubbingRequest.updateDubbingRequestByKey(
        'voice',
        dubbingVoices[0] || {},
      ),
    );
  };

  const handleChangeVoice = (value) => {
    dispatch(actions.dubbingRequest.updateDubbingRequestByKey('voice', value));
  };

  const handleOpenVoices = (value) => setOpenVoices(value);

  const handleCloseVoices = () => setOpenVoices(false);

  useEffect(() => {
    setDefaultVoice();
  }, []);

  return (
    <StyledMenuVoice>
      <Button
        id="buttonMenu"
        className="open-menu-voice"
        onClick={handleOpenVoices}
      >
        <BadgeAvatar
          width={25}
          smallImgWidth={10}
          img={voice?.roundImage}
          smallImg={voice && voice.language && voice.language.roundImage}
          type="image"
        />
        <Typography
          variant="body2"
          className={
            isInValidPublicVoiceCloning
              ? 'invalid-voice-name'
              : 'name-voice-select'
          }
        >
          {voice && voice.name}
        </Typography>
      </Button>
      <LimitedFeature voiceFeatures={voice?.features} />
      {isVoiceCloningAboutToRemoved && (
        <Tooltip
          arrow
          title={t('voiceCloningDiscardAt', {
            date: convertFormatDate(voice?.discardAt),
          })}
          placement="top"
        >
          <RunningWithErrorsRoundedIcon className="returning-error-icon" />
        </Tooltip>
      )}
      {isInValidPublicVoiceCloning && (
        <Tooltip arrow title={t('invalidPublicVoiceCloning')} placement="top">
          <RunningWithErrorsRoundedIcon className="returning-error-icon" />
        </Tooltip>
      )}

      <VoiceSelectionDialog
        open={openVoices}
        onClose={handleCloseVoices}
        onChangeVoice={handleChangeVoice}
        isDubbing
        activeVoiceCode={voice && voice.code}
        voiceStatus={voice && voice.status}
        provider={VOICE_PROVIDER.VBEE}
        forceLanguage="vi"
      />
    </StyledMenuVoice>
  );
};

export default MenuVoice;
